import { render, staticRenderFns } from "./singleChoice.vue?vue&type=template&id=431b32ed&scoped=true&"
import script from "./singleChoice.vue?vue&type=script&lang=js&"
export * from "./singleChoice.vue?vue&type=script&lang=js&"
import style0 from "./singleChoice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./singleChoice.vue?vue&type=style&index=1&id=431b32ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b32ed",
  null
  
)

export default component.exports